<template>
	<div class="page-content">
		
		<div class="logo-wrapper">
			<div class="logo adequation"><img src="@/assets/img/logo-adequation.png" alt="ADEQUATION"></div>
			<div class="logo cdc"><img src="@/assets/img/cdc-habitat.png" alt="CDC Habitat"></div>
		</div>

		<div class="main-name">
			<!-- PREFIX -->
			<p class="main-name__upper title-segment">{{title}}</p>
			<div class="main-name__address-row">
				<el-textarea class="main-name__upper" :parent_data="active_study.etudeData" property="residence" :editable="true" />
				<span class="main-name__address-row__separator"> - </span>
				<el-textarea class="main-name__upper" :parent_data="active_study.etudeData" property="titre" :editable="true" />
				<span class="main-name__address-row__separator"> - </span>
				<el-textarea class="main-name__upper" :parent_data="active_study.etudeData" property="sous_titre" :editable="true" />
			</div>
		</div>
		<el-title :index="index" :parent_data="active_study.etudeData.gie.sectionAnalyseDeSite"
					property="titre"
					:editable="true">
			Analyse des forces et faiblesses du site :
		</el-title>
		<section-gie-analyse-de-site />
		
		<el-title :index="index + 1" :parent_data="active_study.etudeData.gie.sectionDynamiqueTerritoriale"
					property="titre"
					:editable="true">
					Dynamique territoriale et caractéristiques des ménages :
		</el-title>
		<section-gie-dynamique-territoriale />
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import SectionGieAnalyseDeSite from "@/components/study/editor/pages/sections/section-gie-analyse-de-site";
import SectionGieDynamiqueTerritoriale from "@/components/study/editor/pages/sections/section-gie-dynamique-territoriale";

export default {
	name: "page-gie-1",
	mixins: [ PageMixin ],
	components: { SectionGieAnalyseDeSite, SectionGieDynamiqueTerritoriale },
	props: [ "index" ],
	data: function () {
		return {
			form: {
				title: ""
			}
		};
	},
	computed: {
		...mapGetters([ "active_study" ]),
		title: function () {
			if(this.active_study.etudeType.nom==="Flash"){
				return "Etude Flash - Valorisation patrimoine";
			}else{
				return "Etude - Valorisation patrimoine";
			}
		}
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

.logo-wrapper
	padding 18px 30px
	display flex
	justify-content space-between

.logo
	height 40px
	width auto
	
	img
		height 100%
		width auto
.title-segment
	font-size 20px
.main-name
	padding 5px
	text-align center
	font-size 18px
	line-height 28px
	font-weight bold
	background-color main_color
	color #fff
	z-index 10001
	
	.el-textarea
		line-height 28px

	&__upper
		text-transform uppercase

	&__address-row
		display flex
		justify-content center
		align-items flex-start
		text-align left

		&__separator
			margin-left 10px
			margin-right 10px

</style>